import React from 'react';
import { useFormikContext } from 'formik';
import { Button } from 'react-covideo-common';
import { NewModal } from 'lib/components';
import { Flex } from 'lib/components/styles/layout';
import { ParagraphSmall } from 'lib/components/styles/typography';
import { FormikInputField } from 'lib/components/formik/FormikInputField';
import { ILandingPageBuilderForm } from '../../../types';
import { useTheme } from 'styled-components/macro';

interface ISaveUIKitModalProps {
  closeModalHandler: () => void;
  onSubmitHandler: () => void;
  selectedUIKitIndex: number;
  isLoading?: boolean;
}

export const SaveUIKitModal = ({
  closeModalHandler,
  onSubmitHandler,
  selectedUIKitIndex,
  isLoading,
}: ISaveUIKitModalProps) => {
  const { errors } = useFormikContext<ILandingPageBuilderForm>();
  const theme = useTheme();

  const hasUiKitsError =
    !!errors.uiKits && Object.values(errors.uiKits).some(err => !!err);

  return (
    <NewModal
      headerText='Save as New UI Kit'
      closeModal={closeModalHandler}
      style={{
        content: {
          maxHeight: 284,
          width: 592,
          maxWidth: 592,
          padding: '22px 42px',
        },
      }}
    >
      <Flex gap='24px'>
        <ParagraphSmall style={{ color: theme.colors.neutral[80] }}>
          Please add a new name to this UI Kit
        </ParagraphSmall>
        <FormikInputField
          label='UI Kit Name'
          name={`uiKits[${selectedUIKitIndex}].title`}
          type='text'
          isRequired
          autoFocus={true}
          disabled={isLoading}
        />
        <Flex flexDirection='row' width='100%' justifyContent='flex-end'>
          <Button
            text={'Save'}
            loading={isLoading}
            disabled={hasUiKitsError || isLoading}
            onClick={onSubmitHandler}
            type='submit'
          />
        </Flex>
      </Flex>
    </NewModal>
  );
};
